export default "__VITE_ASSET__Cx5OQQGm__"